import { Link, useLocation } from "react-router-dom";
import { useUnreadChatsCount } from "@/hooks/useUnreadChats";
import { useTranslations } from "@/contexts/I18nContext";

const navItems = [
  { href: "/dashboard", labelKey: "sidebar.home", icon: "home" },
  { href: "/posts", labelKey: "sidebar.posts", icon: "posts" },
  { href: "/chats", labelKey: "sidebar.chats", icon: "chats" },
  { href: "/account", labelKey: "sidebar.account", icon: "account" },
];

function NavIcon({ name, active }: { name: string; active: boolean }) {
  const color = active ? "var(--accent-color)" : "currentColor";
  const strokeWidth = active ? "2.5" : "2";

  switch (name) {
    case "home":
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      );
    case "posts":
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" />
        </svg>
      );
    case "chats":
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      );
    case "account":
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
        </svg>
      );
    default:
      return null;
  }
}

export function BottomNav() {
  const { pathname } = useLocation();
  const unreadChatsCount = useUnreadChatsCount();
  const t = useTranslations();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 sm:hidden">
      <div className="flex items-center justify-around h-16 pb-safe">
        {navItems.map((item) => {
          const active = pathname.startsWith(item.href);
          const showBadge = item.href === "/chats" && unreadChatsCount > 0;
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`relative flex flex-col items-center gap-1 px-3 py-2 ${
                active ? "text-[color:var(--accent-color)]" : "text-gray-500"
              }`}
            >
              <div className="relative">
                <NavIcon name={item.icon} active={active} />
                {showBadge && (
                  <span
                    className="absolute -top-1 -right-1.5 min-w-[16px] h-4 px-1 rounded-full text-white text-[10px] font-bold flex items-center justify-center"
                    style={{ backgroundColor: "var(--accent-color, #00C7BE)" }}
                  >
                    {unreadChatsCount}
                  </span>
                )}
              </div>
              <span className="text-[11px]">{t(item.labelKey)}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
